import React, { useEffect, useState } from 'react';
import { adminListCampusDrives, adminUpdateCampusDrive } from '../../lib/api';
import { Loader2, GraduationCap } from 'lucide-react';

const STATUS_STYLES = {
  new: 'bg-blue-50 text-blue-700 border-blue-200',
  contacted: 'bg-amber-50 text-amber-700 border-amber-200',
  scheduled: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  closed: 'bg-slate-100 text-slate-500 border-slate-200',
};

export default function AdminCampusTab() {
  const [reqs, setReqs] = useState(null);

  const load = () => adminListCampusDrives().then(setReqs).catch(() => setReqs([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => { await adminUpdateCampusDrive(id, status); load(); };

  return (
    <div className="rounded-2xl border bg-white overflow-hidden" data-testid="campus-tab">
      <div className="px-5 py-4 border-b font-bold flex items-center gap-2">
        <GraduationCap className="h-4 w-4 text-orange-500" /> Campus Drive Requests {reqs ? `(${reqs.length})` : ''}
      </div>
      {reqs === null ? (
        <div className="py-16 text-center text-slate-500"><Loader2 className="h-5 w-5 mx-auto animate-spin" /></div>
      ) : reqs.length === 0 ? (
        <div className="py-16 text-center text-slate-500">No campus drive requests yet — the form is live on the Careers page.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-100 text-slate-700">
              <tr>
                <th className="text-left px-4 py-2.5">College</th>
                <th className="text-left px-4 py-2.5">Contact</th>
                <th className="text-left px-4 py-2.5">City</th>
                <th className="text-left px-4 py-2.5">Batch</th>
                <th className="text-left px-4 py-2.5">Preferred dates</th>
                <th className="text-left px-4 py-2.5">Received</th>
                <th className="text-left px-4 py-2.5">Status</th>
              </tr>
            </thead>
            <tbody>
              {reqs.map((r) => (
                <tr key={r.id} className="border-t align-top" data-testid={`campus-row-${r.id}`}>
                  <td className="px-4 py-3">
                    <div className="font-semibold">{r.college_name}</div>
                    {r.message && <div className="text-xs text-slate-500 mt-0.5 max-w-[220px]">{r.message}</div>}
                  </td>
                  <td className="px-4 py-3">
                    <div>{r.contact_person}</div>
                    <div className="text-xs text-slate-500">{r.email}</div>
                    <div className="text-xs text-slate-500">{r.phone}</div>
                  </td>
                  <td className="px-4 py-3">{r.city}</td>
                  <td className="px-4 py-3">{r.batch_size || '—'}</td>
                  <td className="px-4 py-3">{r.preferred_dates || '—'}</td>
                  <td className="px-4 py-3 text-xs text-slate-500">{r.created_at ? new Date(r.created_at).toLocaleString() : '—'}</td>
                  <td className="px-4 py-3">
                    <select
                      data-testid={`campus-status-${r.id}`}
                      value={r.status}
                      onChange={(e) => setStatus(r.id, e.target.value)}
                      className={`text-xs rounded-full border px-2 py-1 font-semibold ${STATUS_STYLES[r.status] || ''}`}
                    >
                      <option value="new">New</option>
                      <option value="contacted">Contacted</option>
                      <option value="scheduled">Scheduled</option>
                      <option value="closed">Closed</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
